"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryList = void 0;
const Query_1 = require("./Query");
function useQueryList(options) {
    return Query_1.useQuery(options);
}
exports.useQueryList = useQueryList;
//# sourceMappingURL=QueryList.js.map